import { PETS_LOAD } from '../../actions';

const petsReducer = (
  oldState = {
    petsVm: new Map()
  },
  action,
) => {
  switch (action.type) {
    case PETS_LOAD:
      return {
        ...oldState,
        petsVm: new Map(action.response.map(pet => ([pet.id, pet.data()])))
      };
    default:
      return oldState;
  }
};

export default petsReducer;



// WEBPACK FOOTER //
// ./src/pages/Pets/petsReducer.js